<template>
  <div>
    <md-table v-model="collections" md-card>
      <md-table-toolbar class="md-primary">
        <h1 class="md-title">
          Workspace :
          <pre><strong> {{workspace}} </strong> </pre>
        </h1>
        <br />
        <h1 class="md-title">
          Environment :
          <pre><b> {{env}}</b></pre>
          &nbsp;
        </h1>
      </md-table-toolbar>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Collection Name" md-sort-by="name">{{
          item.collectionName
        }}</md-table-cell>
        <md-table-cell md-label="" :id="item.collectionId + '_spinner'">
          <md-progress-spinner
            :md-diameter="60"
            :md-stroke="10"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <div>
            <b :id="item.collectionId + '_status'">{{ status }}</b>
          </div>
        </md-table-cell>
        <md-table-cell
          md-label=""
          :id="item.collectionId + '_button'"
          style="display:none"
        >
          <md-button
            class="md-raised md-primary"
            @click="displayReport(item.collectionName, item.collectionId)"
            target="_blank"
            >Display Report</md-button
          >
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "TableTemplate",
  props: ["collections", "workspace", "env"],
  data() {
    return {
      baseUrl: "https://2z0gwmeteh.execute-api.eu-west-1.amazonaws.com/newman",
      status: "PENDING",
      timer: null,
      collectionArray: []
    };
  },
  mounted() {
    this.collectionArray = JSON.parse(JSON.stringify(this.collections));
    this.timer = window.setInterval(() => {
      this.refreshStatus();
    }, 10000);
  },
  methods: {
    displayReport(collectionName, collectionId) {
      window.open(
        "https://wcc-newman-reports-rec.s3.eu-west-1.amazonaws.com/reports/" +
          collectionName +
          "_" +
          collectionId +
          ".html",
        "_blank"
      );
    },
    refreshStatus() {
      const collectionArray = JSON.parse(JSON.stringify(this.collectionArray));

      const x = collectionArray.length
      var i = 0;

      while(x > i) {
        this.handleRequest(collectionArray, i);
        i++;
      }
    },
    handleRequest(collectionArray, i) {
        const collectionId = collectionArray[i].collectionId
        const collectionName = collectionArray[i].collectionName
        const headers = { "Content-Type": "*/*" };
        this.$http
          .get(
            this.$data.baseUrl +
              "/get-report?collectionName=" +
              collectionName +
              "&collectionId=" +
              collectionId,
            { headers }
          )
          .then(
            result => {
              const status = result.data;
              if (status === "DONE") {
                // display report
                document.getElementById(
                  collectionId + "_spinner"
                ).style.display = "none";
                document.getElementById(
                  collectionId + "_button"
                ).style.display = "inline";

                //send email when done
                const email = localStorage.getItem('email');
                this.sendEmail(email, collectionName, collectionId);
                this.collectionArray.splice(i,1);
              }

              if (status) {
                document.getElementById(
                  collectionId + "_status"
                ).innerHTML = status;
              }
            },
            err => {
              document.getElementById(collectionId + "_spinner").style.display =
                "none";
              document.getElementById(collectionId + "_button").style.display =
                "none";
              document.getElementById(collectionId + "_status").innerHTML =
                "FAIL";
            }
          );
    },
    sendEmail(email, collectionName, collectionId){
      const headers = { "Content-Type": "*/*" };

      const link = "https://wcc-newman-reports-rec.s3-website-eu-west-1.amazonaws.com/reports/" +
          collectionName +
          "_" +
          collectionId +
          ".html";
      const body = {
        email, collectionName, collectionId, link
      }
      this.$http
          .post(
            this.$data.baseUrl + "/send-email",
            { headers, body }
          ).then(res => {
            //console.log(res)
          });
    }

  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
